module.exports = __webpack_public_path__ + "static/img/hsimg.13e2fcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hsimg.png
// module id = Y13r
// module chunks = 0